export const currentDate = new Date();
export const dateFormatString = 'DD/MM/YYYY';
export const numberFormatString = '##/##/####';
export const genericMinDate = new Date('1800-01-01T00:00:00.000Z');
